import { Box, Divider, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import ProposalInformationChips from "./proposal-includes";
import MainSpecsFilter from "./main-specs";
import { mainSpecsOptions, proposalIncludesOptions } from "@/modules/property-tracks/constants";
import { ProposalDetailsFormFields } from "@/modules/property-tracks/hooks/rental-financial-proposal/multi-step-form.hook";

export default function ProposalDetailsForm({
  form,
}: {
  form: UseFormReturn<ProposalDetailsFormFields>;
}) {
  return (
    <Box>
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        Proposal information
      </Typography>
      <Box
        sx={(t) => ({
          display: "flex",
          flexDirection: "column",
          gap: t.nawy.spacing.md,
        })}
      >
        <ProposalInformationChips
          options={proposalIncludesOptions}
          form={form}
        />
      </Box>
      <Divider sx={(t) => ({ my: t.nawy.spacing.lg })} />
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        Main Specs
      </Typography>
      <Box
        sx={(t) => ({
          display: "flex",
          flexDirection: "column",
          gap: t.nawy.spacing.md,
        })}
      >
        <MainSpecsFilter options={mainSpecsOptions} form={form} />
      </Box>
    </Box>
  );
}
